export const PRICE_BADGE_PADDING_X = 12

const PRICE_CHAR_WIDTH = {
  digit: 11,
  separator: 5,
  currencyChar: 12,
  gap: 5,
  paddingX: PRICE_BADGE_PADDING_X,
} as const

export type BadgePrice = {
  amount: string
  currency: string
  currencyFirst: boolean
}

// Region formatter for the number, our own sign for the currency token
export const formatBadgePrice = (
  formatter: Intl.NumberFormat,
  value: number,
  currencySign: string
): BadgePrice => {
  const parts = formatter.formatToParts(Math.max(0, value))
  const currencyIndex = parts.findIndex((part) => part.type === 'currency')
  const integerIndex = parts.findIndex((part) => part.type === 'integer')
  const amount = parts
    .filter((part) => part.type !== 'currency')
    .map((part) => part.value)
    .join('')
    .trim()

  return {
    amount,
    currency: currencySign,
    currencyFirst: currencyIndex !== -1 && currencyIndex < integerIndex,
  }
}

const isDigit = (char: string) => char >= '0' && char <= '9'

// Estimate only; the badge corrects itself once the content is measured
export const getPriceWidth = ({ amount, currency }: BadgePrice) => {
  const { digit, separator, currencyChar, gap, paddingX } = PRICE_CHAR_WIDTH

  const amountWidth = [...amount].reduce(
    (sum, char) => sum + (isDigit(char) ? digit : separator),
    0
  )

  return (
    amountWidth +
    gap +
    Math.max(1, currency.length) * currencyChar +
    paddingX * 2
  )
}

export const getPriceInnerContentWidth = (price: BadgePrice) =>
  getPriceWidth(price) - PRICE_BADGE_PADDING_X * 2
